export default "__VITE_ASSET__BytEilw3__"